var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListorderedactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16663 3H14.5M7.16663 6.33333H14.5M7.16663 9.66667H14.5M7.16663 13H14.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87995 2.92766L4.8966 2.32422V4.88379",
    stroke: "white",
    strokeWidth: 0.835193,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98931 7.41795C4.62752 6.68209 5.52758 7.23703 5.03426 8.00086C4.13741 8.98564 3.88 9.20791 3.88 9.27739L5.13245 9.2793",
    stroke: "white",
    strokeWidth: 0.731709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98083 11.7191C4.5384 11.2391 5.44606 11.4863 5.15632 12.1252C4.9274 12.4971 4.40873 12.5366 4.55785 12.5366C5.25156 12.4394 5.41701 13.0963 5.02465 13.3535C4.52689 13.6799 4.06831 13.3663 3.88 13.169",
    stroke: "white",
    strokeWidth: 0.648305,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListorderedactive);
export default __webpack_public_path__ + "static/media/listorderedactive.03e660712e0592d689ada3c1fe21c8b9.svg";
export { ForwardRef as ReactComponent };